<template>
  <div id="app">
    <div class="mainWrapper" style="background: black;" v-show="loadContent">
      <div class="headerTop" ref="headerContainer">
        <span v-show="windowWidth > 700" class="banner bannerAnimation">60 Jahre THAV!</span>
        <transition name="opacity">
          <img class=""
               :class="[getClass, 'previewImage']"
               :key="showBg[1]"
               :src="showBg[1]">
        </transition>
        <div style="position: absolute; left: 30%; top: 100px;"
             :style="windowWidth > 800 ? {left: 20 + '%'} : {left: 5 + '%'}">
          <h3 ref="T"
              class="headerT bigFont"
              :key="getHeader(0)"
              >{{getHeader(0)}}</h3>
          <h3 ref="H"
              class="headerH bigFont"
              :key="getHeader(1)"
              >{{getHeader(1)}}</h3>
          <h3 ref="A"
              class="headerA bigFont"
              :key="getHeader(2)"
              >{{getHeader(2)}}</h3>
          <h3 ref="V"
              class="headerV bigFont"
              :key="getHeader(3)"
              >{{getHeader(3)}}</h3>
          <h3 class="headerFull bigFont"
              :key="getHeader(4)"
              >{{getHeader(4)}}</h3>
          <div class="verticalLine">
          </div>
        </div>
        <div class="schauHier" v-show="windowWidth > 700"
          :style="windowWidth > 1200 ? {right: 35 + '%'} : {right: 25 + '%'}">
          <h3 class="bigFont lookHere"><a href="#kalender"
          v-smooth-scroll="{ duration: 800 }">Direkt zu den Konzerten <br>
            schau hier >></a></h3>
          <div class="schauHierBg">
            <div class="horizontalLine1" />
            <div class="horizontalLine2" />
            <div class="horizontalLine3" />
          </div>
        </div>
        <div class="greengreengras" v-show="windowWidth > 500"
          :style="windowWidth > 1200 ? {right: 10 + '%'} : {right: 25 + '%'}"
          >
          <p class="barItem fromBottom0 frederika"><a @mouseover="showBg = ['', require('./assets/thavRedBig.png'), 'thav']"
               @mouseout="showBg = ''"
               href="#thav"
               v-smooth-scroll="{ duration: 400 }">THAV</a></p>
          <p class="barItem fromBottom1 frederika"><a @mouseover="showBg = ['', require('./assets/thavRedBigMobile.png'), 'haeusliches']" @mouseout="showBg = ''" href="#haeusliches"
               v-smooth-scroll="{ duration: 800 }">HÄUSLICHES</a></p>
          <p class="barItem fromBottom2 frederika"><a @mouseover="showBg = ['', require('./assets/thavAtmosphäre.jpg'), 'atmosphaere']" @mouseout="showBg = ''" href="#atmosphaere"
               v-smooth-scroll="{ duration: 1200 }">ATMOSPHÄRE</a></p>
          <p class="barItem fromBottom3 frederika"><a @mouseover="showBg = ['', require('./assets/thavVerantaltungen.png'), 'veranstaltungen']" @mouseout="showBg = ''" href="#veranstaltungen"
               v-smooth-scroll="{ duration: 1600 }">VERANSTALTUNGEN</a></p>
          <div class="horizontalLine" :style="showBg == '' ? {background: '#921818'} : {background: '#921818'}" />
        </div>
      </div>
      <div class="headerTopBg" :class="menuBar ? ['visibleShadow', 'boxShadowBelow'] : ['visibleShadowOff', 'boxShadowBelow']" ref="menuBar" v-if="tabbar">
        <h1 class="headlineMenu"><a href="#app" v-smooth-scroll="{ duration: 1200 }"
            :style="menuBar ? {opacity: 1, 'pointer-Events': 'all'} : {opacity: 0, 'pointer-Events': 'none'}"
          >THAV</a></h1>
        <div v-if="windowWidth > 800"
             class="greengreengrasMenu opacity"
             :style="menuBar ? {opacity: 1, 'pointer-Events': 'all'} : {opacity: 0, 'pointer-Events': 'none'}">
          <p class="barItem barItemBig fromBottom0 frederika"><a href="#thav" v-smooth-scroll="{ duration: 1200 }">THAV</a></p>
          <p class="barItem barItemBig fromBottom1 frederika"><a href="#haeusliches" v-smooth-scroll="{ duration: 1200 }">HÄUSLICHES</a></p>
          <p class="barItem barItemBig fromBottom2 frederika"><a href="#atmosphaere" v-smooth-scroll="{ duration: 1200 }">ATMOSPHÄRE</a></p>
          <p class="barItem barItemBig fromBottom3 frederika"><a href="#veranstaltungen" v-smooth-scroll="{ duration: 1200 }">VERANSTALTUNGEN</a></p>
        </div>
        <div v-else style="width: 100%"
             class="opacity"
             :style="menuBar ? {opacity: 1, 'pointer-Events': 'all'} : {opacity: 0, 'pointer-Events': 'none'}">
          <Slide right>
            <h2 class="headerT"><a href="#thav" v-smooth-scroll="{ duration: 800 }">THAV</a></h2>
            <h2 class="headerH"><a href="#haeusliches" v-smooth-scroll="{ duration: 800 }">HÄUSLICHES</a></h2>
            <h2 class="headerA"><a href="#atmosphaere" v-smooth-scroll="{ duration: 800 }">ATMOSPHÄRE</a></h2>
            <h2 class="headerV"><a href="#veranstaltungen" v-smooth-scroll="{ duration: 800 }">VERANSTALTUNGEN</a></h2>
          </Slide>
        </div>
        <vue-scroll-progress-bar backgroundColor="#921818"
                                 containerColor="#000000"
                                 height="8px"/>
      </div>
      <main id="page-wrap">
        <baseSection id="thav" :windowWidth="windowWidth" :content="content[0]" @hideTabbar="tabbar = false; log()" @releaseTabbar="tabbar = true; log()">
          <gallery :images="images"/>
          <p>Fotos: ©Pia Wehrmaker</p>
        </baseSection>
        <baseSection id="haeusliches" :windowWidth="windowWidth" :content="content[1]" @hideTabbar="tabbar = false; log()" @releaseTabbar="tabbar = true; log()">
        </baseSection>
        <baseSection id="atmosphaere" :windowWidth="windowWidth" :content="content[2]" @hideTabbar="tabbar = false; log()" @releaseTabbar="tabbar = true; log()">
        </baseSection>
        <baseSection id="veranstaltungen" :windowWidth="windowWidth" :content="content[3]" @hideTabbar="tabbar = false; log()" @releaseTabbar="tabbar = true; log()">
          <eventCalendar class="calendar" id="kalender"/>
          <h2>Gefällts dir? dann meld dich unter info@kneipe-ohne-fenster.de!</h2>
          <h2>Cheerio und bis dahin!</h2>
        </baseSection>
        <div class="footer">
          <div class="footerInner">
            <p>THAV</p>
            <h2>Güntherstraße 21</h2>
            <h2>31135 Hilesheim</h2>
            </br>
            <div style="display: flex; width:150px; margin:auto;">
              <a style="position: reative; width:50%" href="https://www.instagram.com/explore/locations/32843196/thav/">
                <img  src="./assets/insta.png">
              </a>
              <a style="position: reative; width:50%" href="https://www.facebook.com/Thav.Hildesheim/">
                <img  src="./assets/fb.png">
              </a>
            </div>
            </br>
            <div>
              <h3 @click="fillPopUp('impressum')">Impressum </h3>
            </div>
            <div>
              <h3 @click="fillPopUp('datenschutz')">Datenschutz</h3>
            </div>
          </div>
        </div>
      </main>
    </div>
    <transition name="opacity">
      <popUp v-if="popUpContent.show" :content="popUpContent.content" v-on:close="fillPopUp('none')"/>
    </transition>

    <div class="loading" v-show="!loadContent">
      <h1 style="opacity: 0">t</h1>
    </div>
  </div>

</template>

<script>

  import eventCalendar from './components/eventCalendar'
  import baseSection from './components/baseSection'
  import bigSection from './components/bigSection'
  import { Slide } from 'vue-burger-menu'
  import popUp from './components/popUp'
  import gallery from './components/gallery/gallery.vue'
  import { throttle, debounce } from 'throttle-debounce';

  export default {
    name: 'app',
    data: () => {
      return {
        showBg: '',
        tabbar: true,
        fixed: false,
        popUpContent: {
          headline: "",
          main: "",
          show: false
        },
        vfOptions: {
         autoplay: true
        },
        images: [
          require('./assets/thav/Thav-candle.jpg'),
          require('./assets/thav/DSC_0011.jpg'),
          require('./assets/thav/DSC_0017.jpg'),
          require('./assets/thav/DSC_0023.jpg'),
          require('./assets/thav/DSC_0025.jpg'),
          require('./assets/thav/DSC_0029.jpg'),
          require('./assets/thav/DSC_0030.jpg'),
      ],
        content: [
          {
            index: 0,
            withSlot: true,
            is: 'thav',
            headline: 'THAV',
            subheadline: 'Die Kneipe ohne Fenster',
            text:
              'Dafür mit einer Tür, die euch 6 Tage die Woche offen steht! Falls ihr uns noch nicht kennt, traut euch selbst durch die bunte Tür, \
              um einen mindestens genau so bunten Abend zu erleben.\
              </br>\
              </br>\
              Vielfalt erfülle Leib und Seele!',
            tweenImage: require('./assets/thavRedBig.png'),
            tweenImageMobile: require('./assets/thavRedBigMobile.png')
          },
          {
            index: 1,
            withSlot: true,
            is: 'HÄUSLICHES',
            headline: 'HÄUSLICHES',
            subheadline: 'Das haben wir für dich parat:',
            text:
              'Sämtliche Biersorten, Weine, Schnaps, Cocktails, Säfte, \
               2 astreine(!) Kickertische, eine nicht mehr ganz so astreine Dartscheibe, \
               eine Bar mit offenen Ohren, leuchtenden Spiralen und Blechfischen! \
               Außerdem ein knackiges Programm, schauts euch doch unten im Kalender an!',
            tweenImage: require('./assets/thav/DSC_0011.jpg'),
            tweenImageMobile: require('./assets/Thav-candle-mobile.jpg')
          },
          {
            index: 2,
            is: 'ATMOSPHÄRE',
            headline: 'ATMOSPHÄRE',
            subheadline: 'erst durch euch',
            text:
              '..können wir stolz auf das Thav sein. Erst recht wenn ihr zuhauf die Theke belagert, \
              die Bühne stürmt, die Toiletten mit eurem Lieblingsbandaufkeber verseht oder \
              plötzlich sofas(!) in der Einfahrt stehen. Diesen Sommer hatten wir also eine gemütliche Sofaecke, \
              astrein! </br> Weiter so, Hildesheim!',
            tweenImage: require('./assets/thavAtmosphäre.jpg'),
            tweenImageMobile: require('./assets/thavAtmosphäreMobile.jpg')
          },
          {
            index: 3,
            withSlot: true,
            is: 'Veranstaltungen',
            headline: 'Veranstaltungen',
            subheadline: 'du brauchst VIEL.MEHR.LIVE:MUSIK',
            text: 'Du spürst es. Du fühlst es. Du weißt es: Du brauchst es mal wieder! ;) </br> \
               Konzerte sind selten geworden sagen die Leute, \
               davon merken wir hier nichts. Freitags POP. Samstags Metal und Montags Blues? Wilkommen im Thav.</br> \
               Der Kalender ist jetzt schon so gut gefüllt, dass ihr besimmt was für euch findet.',
            tweenImage: require('./assets/thavVerantaltungen.png'),
            tweenImageMobile: require('./assets/thavVerantaltungenMobile.png')
          }
        ],
        maxScroll: 0,
        tweenVal: 0,
        loadContent: false,
        menuOffSetTop: 0,
        menuBar: false,
        windowWidth: 0,
        burgerOpen: false,
      }
    },
    computed: {
      getClass() {
        return this.showBg[0]
      }
    },
    components: {
      eventCalendar,
      baseSection,
      bigSection,
      Slide,
      popUp,
      gallery,
    },
    methods: {
      log() {
        console.log("qweqweqwe")
      },
      fillPopUp(content){
        if(content == "datenschutz"){
          this.popUpContent.content = "datenschutz"
          this.popUpContent.show = true;
        } else if (content == "impressum"){
          this.popUpContent.content = "impressum"
          this.popUpContent.show = true;
        } else if (content == 'none'){
          this.popUpContent.show = false;
          this.popUpContent.content = ""
        }
      },
      getHeader(index){

        let options = {
          default:[
            'Hi!     schön, dass du da bist.',
            'Wir',
            'sind',
            'das',
            'Thav'
          ],
          thav:[
            'Komm her',
            'trink',
            'iss',
            'Poloch',
            'Arsch',
          ],
          haeusliches:[
            'Wir ham',
            'hier auch ne Menge',
            'lram n shor',
            'Kacke',
            'Kacke'
          ],
          atmosphaere:[
            'das',
            'als andauernd nur noch auf dein',
            'im',
            'Worst',
            'Case'
          ],
          veranstaltungen:[
            'MUKKE',
            'akjdndf',
            'AAAAAARSCH',
            'AAAAAARSCH',
            'AAAAAARSCH'
          ]
        }
        return options.default[index]

      },
      scrollCallback() {
        if (window.scrollY > this.menuOffSetTop) {
          this.menuBar = true
        } else {
          this.menuBar = false
        }
      },
      resizeCallback() {
        this.menuOffSetTop = this.$refs.headerContainer.clientHeight
        this.windowWidth = window.innerWidth
      }
    },
    mounted() {

      window.addEventListener('scroll', throttle(300, () => {
        this.scrollCallback()
        })
      );
      window.addEventListener('resize', throttle(300, () => {
        this.resizeCallback()
        })
      );
      this.menuOffSetTop = this.$refs.menuBar.offsetTop
      this.windowWidth = window.innerWidth

      setTimeout(() => {
        this.loadContent = true
      }, 1000)
      setTimeout(() => {
        this.menuOffSetTop = this.$refs.headerContainer.clientHeight
      }, 1000)
      setTimeout(() => {
        this.menuBar = window.scrollY > this.menuOffSetTop * 0.7
      }, 1000)
    },
    beforeDestroy() {
      window.removeEventListener('scroll', throttle(300, () => {
        this.scrollCallback()
        })
      );
      window.removeEventListener('resize', throttle(300, () => {
        this.resizeCallback()
        })
      );
    }
  }

</script>

<style lang="scss">

  @import url('https://fonts.googleapis.com/css?family=Poppins');
  @import url('https://fonts.googleapis.com/css?family=Fredericka+the+Great&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Amatic+SC&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Six+Caps&display=swap');

  body {
    font-family: 'Amatic SC', cursive;
    margin: 0;
    overflow-x: hidden;
    text-align: left;
  }
  p,
  h2,
  h3 {
    margin: 0;
  }
  h1 {
    font-family: 'Amatic SC';
    margin: 0;
    font-weight: bold;
  }
  .frederika {
    font-family: 'Amatic SC';
  }

  span {
    font-size: 1.4em;
  }
  p {
    font-size: 2em;
    color: white;
  }
  a {
    transition: transform color 0.3s;
    text-decoration: none;
    color: white;
  }
  a:visited {
    color: white;
  }
  a:hover {
    transform: scale(1.2);
    color: #921818;
  }

  h1 {
    font-size: 3em;
    font-weight: normal;
  }
  h2 {
    font-size: 1.625em;
    font-weight: normal;
  }
  h3 {
    font-size: 1.375em;
    font-weight: normal;
  }
  h4,
  textarea,
  input {
    font-size: 1.125em;
    font-weight: normal;
  }
  @media only screen and (min-width: 700px) {
    body {
      font-size: 1.1em;
    }
    h1 {
      font-size: 3em;
    }
    h2 {
      font-size: 2.25em;
    }
    h3 {
      font-size: 3em;
    }
    h4,
    textarea,
    input {
      font-size: 1.125em;
    }
  }

  blockquote {
    font-size: 0.8em;
    padding-top: 5px;
    padding-right: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    border-top-width: 1px;
    border-right-width: 1px;
    border-bottom-width: 1px;
    border-left-width: 1px;
    border-top-style: solid;
    border-right-style: solid;
    border-bottom-style: solid;
    border-left-style: solid;
    border-top-color: #999999;
    border-right-color: #999999;
    border-bottom-color: #999999;
    border-left-color: #999999;
    background-color: #dedede;
  }

  ul {
    font-size: 0.8em;
    font-variant: small-caps;
  }

  .boxShadow {
    box-shadow: 0px 0px 5px rgba(40, 40, 40, 0.8);
  }
  .boxShadowBelow {
    box-shadow: 0 4px 4px 0px rgba(40, 40, 40, 0.6);
  }
  .boxShadowTop {
    box-shadow: 0 -4px 4px 0px rgba(40, 40, 40, 0.6);
  }
  .filterShadow {
    filter: drop-shadow(0px 0px 4px rgba(40, 40, 40, 0.8));
  }
  .filterShadowBelow {
    filter: drop-shadow(0px 7px 3px rgba(40, 40, 40, 0.5));
  }
  .filterShadowTop {
    filter: drop-shadow(0px -7px 3px rgba(40, 40, 40, 0.5));
  }

  .deepshadow {
    color: #e0dfdc;
    letter-spacing: 0em;
    text-shadow: 0 -1px 0 #fff, 0 1px 0 #2e2e2e, 0 2px 0 #2c2c2c, 0 3px 0 #2a2a2a, 0 4px 0 #282828, 0 5px 0 #262626,
      0 6px 0 #242424, 0 7px 0 #222, 0 8px 0 #202020, 0 9px 0 #1e1e1e, 0 10px 0 #1c1c1c, 0 11px 0 #1a1a1a,
      0 12px 0 #181818, 0 13px 0 #161616, 0 14px 0 #141414, 0 15px 0 #121212, 0 22px 30px rgba(0, 0, 0, 0.9);
  }
  /*
  html {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  html::-webkit-scrollbar {
    width: 0px;
  }
  */
  .center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .verticalLine {
    position: relative;
    left: -15px;
    width: 10px;
    height: 0px;
    margin-top: -480px;
    animation-name: height;
    animation-duration: 0.7s;
    animation-delay: 0.3s;
    animation-fill-mode: forwards;
    z-index: 0;
    transition: background 2s;
    background: #921818;
  }
  .horizontalLine {
    position: absolute;
    right: 100%;
    top: 0%;
    width: 10px;
    height: 0px;
    animation-name: height2;
    animation-duration: 3s;
    animation-delay: 2s;
    animation-fill-mode: forwards;
    z-index: 0;
    transition: background 2s;
  }
  .schauHier{
    position: absolute;
    display: block;
    bottom: 16%;
    right: 28%;
  }
  .schauHierBg{
    position: absolute;
    display: flex;
    top: 0;
    z-index: 0;
    right: -3%;
  }
  .horizontalLine1{
    width: 10px;
    position: absolute;
    right: 50px;
    background: #921818;
    animation-name: height1;
    animation-delay: 2.6s;
    animation-duration: 0,5s;
    animation-fill-mode: forwards;
  }
  .horizontalLine2{
    width: 10px;
    position: absolute;
    right: 30px;
    background: #921818;
    animation-name: height2;
    animation-delay: 2.4s;
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
  }
  .horizontalLine3{
    width: 10px;
    position: absolute;
    right: 10px;
    background: #921818;
    animation-name: height3;
    animation-duration: 0.5s;
    animation-delay: 2.2s;
    animation-fill-mode: forwards;
  }
  .lookHere{
    opacity: 0;
    animation-name: stamp;
    animation-duration: 1s;
    animation-delay: 2s;
    animation-fill-mode: forwards;
  }
  @keyframes height1 {
    0% {
      height: 0px;
    }
    100% {
      height: 70px;
    }
  }
  @keyframes height2 {
    0% {
      height: 0px;
    }
    100% {
      height: 200px;
    }
  }
  @keyframes height3 {
    0% {
      height: 0px;
    }
    100% {
      height: 110px;
    }
  }



  .bigFont {
    font-size: 3em;
    color: #fff;
    z-index: 1;
    position: relative;
  }
  .headerTop {
    width: 100%;
    position: relative;
    display: block;
    z-index: 1000;
    min-height: 100vh;
    overflow: hidden;
    background: black;
  }
  .headerTopBg {
    width: 100%;
    position: sticky;
    top: 8px;
    display: flex;
    background: black;
    z-index: 1000;
  }
  .previewImage {
    position: absolute;
    width: 30%;
    height: auto;
    top: 10%;
    right: 10%;
    z-index: 5;
  }
  .headline {
    position: relative;
    margin: auto;
    font-size: 8vw;
    color: white;
    text-align: center;
    padding-top: 20vh;
    font-weight: normal;
    z-index: 10;
  }
  .greengreengras {
    font-size: 2em;
    font-weight: normal;
    position: absolute;
    width: 10%;
    bottom: 0;
    right: 10%;
    margin: auto;
    display: block;
    z-index: 5;
  }
  .headlineMenu {
    position: relative;
    margin: 0% 0% 0% 4%;
    font-size: calc(2em + 1vw);
    color: white;
    text-align: center;
    font-weight: normal;
    transition: opacity 1s;
  }
  .visibleShadow{
    pointer-Events: all;
  }
  .visibleShadowOff{
    pointer-Events: none;
  }
  .greengreengrasMenu {
    font-weight: normal;
    position: relative;
    margin: 1% 0% 0% 24%;
    display: flex;
    transition: opacity 1s;
  }
  .barItem {
    margin: 0% 6%;
    font-size: calc(1em + 0.5vw);
  }
  .loading {
    position: relative;
    height: 100vh;
    width: 100vw;
    animation-name: backgroundColor;
    animation-duration: 1s;
    animation-fill-mode: forwards;
  }
  .outer {
    background: orange;
    width: 25%;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    transform: translate(-50%, -50%);
    padding: 1em;
    &:after {
      content: '';
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      padding-bottom: 10%;
      background: orange;
      clip-path: polygon(0% 0%, 100% 0%, 50% 100%);
    }
  }
  .headerT {
    opacity: 0;
    transition: color 0.3s;
    animation-name: stamp;
    animation-delay: 0.2s;
    animation-duration: 0.3s;
    animation-fill-mode: forwards;
  }
  .headerH {
    opacity: 0;
    transition: color 0.3s;
    animation-name: stamp;
    animation-duration: 0.3s;
    animation-delay: 1s;
    animation-fill-mode: forwards;
  }
  .headerA {
    opacity: 0;
    transition: color 0.3s;
    animation-name: stamp;
    animation-duration: 0.3s;
    animation-delay: 1.2s;
    animation-fill-mode: forwards;
  }
  .headerV {
    opacity: 0;
    transition: color 0.3s;
    animation-name: stamp;
    animation-duration: 0.3s;
    animation-delay: 1.4s;
    animation-fill-mode: forwards;
  }
  .headerFull {
    font-size: 10em;
    opacity: 0;
    transition: color 0.3s;
    animation-name: opacity;
    animation-duration: 0.4s;
    animation-delay: 1.6s;
    animation-fill-mode: forwards;
  }
  @keyframes height {
    0% {
      height: 0px;
    }
    100% {
      height: 445px;
    }
  }
  @keyframes height2 {
    0% {
      height: 0px;
    }
    100% {
      height: 400px;
    }
  }
  @keyframes opacity {
    0% {
      opacity: 0;
      transform: scale(0.6);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
  @keyframes backgroundColor {
    0% {
      background-color: white;
    }
    100% {
      background-color: black;
    }
  }
  @keyframes stamp {
    0% {
      opacity: 0;
      transform-origin: 50% 50%;
      transform: scale(2) translateX(100px);
    }
    10% {
      opacity: 0.2;
    }
    40% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
  .fromBottomDirect {
    opacity: 0;
    animation-name: fromBottom;
    animation-duration: 0.2s;
    animation-fill-mode: forwards;
  }
  .fromBottom0 {
    opacity: 0;
    animation-name: fromBottom;
    animation-duration: 0.3s;
    animation-delay: 3s;
    animation-fill-mode: forwards;
  }
  .fromBottom1 {
    opacity: 0;
    animation-name: fromBottom;
    animation-duration: 0.3s;
    animation-delay: 3.1s;
    animation-fill-mode: forwards;
  }
  .fromBottom2 {
    opacity: 0;
    animation-name: fromBottom;
    animation-duration: 0.3s;
    animation-delay: 3.2s;
    animation-fill-mode: forwards;
  }
  .fromBottom3 {
    opacity: 0;
    animation-name: fromBottom;
    animation-duration: 0.3s;

    animation-delay: 3.3s;
    animation-fill-mode: forwards;
  }
  @keyframes fromBottom {
    0% {
      opacity: 0;
    }
    10% {
      opacity: 0.5;
      transform-origin: 50% 50%;
      transform: scale(0.5);
      //transition: all .3s cubic-bezier(0.6, 0.04, 0.98, 0.335);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
  .imageAnimationOpacity {
    -webkit-animation: imageAnimationOpaciy 1s ease-out both;
    animation: imageAnimationOpacity 1s ease-out both;
    animation-fill-mode: forwards;
  }
  @keyframes imageAnimationOpacity {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .imageAnimation {
    -webkit-animation: imageAnimation 5s ease-out both;
    animation: imageAnimation 5s ease-out both;
    animation-fill-mode: forwards;
  }
  @keyframes imageAnimation {
    0% {
      -webkit-transform: scale(1) translateY(10%);
      transform: scale(1) translateY(10%);
      -webkit-transform-origin: 50% 16%;
      transform-origin: 50% 16%;
      opacity: 0;
    }
    100% {
      -webkit-transform: scale(1.2) translateY(0px);
      transform: scale(1.2) translateY(0px);
      -webkit-transform-origin: top;
      transform-origin: top;
      opacity: 1;
    }
  }
  .bannerAnimation {
    -webkit-animation: bannerAnimation 2s ease-out both;
    animation: bannerAnimation 2s ease-out both;
    animation-delay: 2s;
    animation-fill-mode: forwards;
  }
  @keyframes bannerAnimation {
    0% {
      -webkit-opacity: 0;
      opacity: 0;
      transform: rotate(0deg);
    }
    80% {
      -webkit-opacity: 0;
      opacity: 0
    }
    100% {
      -webkit-opacity: 1;
      opacity: 1;
      transform: rotate(45deg);
    }
  }

  .image-bottom-right {
    -webkit-animation: bottom-right 5s ease-in-out reverse both;
    animation: bottom-right 5s ease-in-out reverse both;
  }
  @keyframes bottom-right {
    0% {
      -webkit-transform: scale(1) translate(0, 0);
      transform: scale(1) translate(0, 0);
      -webkit-transform-origin: 84% 84%;
      transform-origin: 84% 84%;
    }
    100% {
      -webkit-transform: scale(1.25) translate(20px, 15px);
      transform: scale(1.25) translate(20px, 15px);
      -webkit-transform-origin: right bottom;
      transform-origin: right bottom;
    }
  }

  .image-top-left {
    -webkit-animation: top-left 5s ease-in-out reverse both;
    animation: top-left 5s ease-in-out reverse both;
  }

  @keyframes top-left {
    0% {
      -webkit-transform: scale(1) translate(0, 0);
      transform: scale(1) translate(0, 0);
      -webkit-transform-origin: 16% 16%;
      transform-origin: 16% 16%;
    }
    100% {
      -webkit-transform: scale(1.25) translate(-20px, -15px);
      transform: scale(1.25) translate(-20px, -15px);
      -webkit-transform-origin: top left;
      transform-origin: top left;
    }
  }

  div.burger {
    position: absolute;
    right: 0;
    width: 50px;
    height: 100%;
    min-height: 44px;
    max-height: 50px;
  }
  div.blueblueoceanMenu {
    position: relative;
    width: 100%;
    margin-top: 10%;
  }

  .barItemBig a::after {
    position: absolute;
    width: 100%;
    left: 0;
    top: 70%;
    height: 3px;
    margin-top: -1px;
    background: #921818;
    content: '';
    z-index: -1;
    -webkit-transition: -webkit-transform 0.3s, opacity 0.3s;
    -moz-transition: -moz-transform 0.3s, opacity 0.3s;
    transition: transform 0.3s, opacity 0.3s;
    pointer-events: none;
  }
  .barItemBig a::before {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0%;
    height: 3px;
    margin-top: -1px;
    background: #921818;
    content: '';
    z-index: -1;
    -webkit-transition: -webkit-transform 0.3s, opacity 0.3s;
    -moz-transition: -moz-transform 0.3s, opacity 0.3s;
    transition: transform 0.3s, opacity 0.3s;
    pointer-events: none;
  }

  .sliderItem{
    height:100%;
    width:100%;
  }

  div.cornerTop{
    width: 100%;
    height: calc(100vw / 20);
    position: absolute;
    background: inherit;
    bottom: calc(100% - 1px);
    clip-path: polygon(0% 100%, 100% 0%, 100% 100%, 0% 100%);
    z-index: 1;
  }
  div.cornerBottom{
    width: 100%;
    height: calc(100vw / 20);
    position: absolute;
    background: inherit;
    top: calc(100% - 1px);
    clip-path: polygon(0% 0%, 100% 0%, 0% 100%, 0% 0%);
    z-index: 1;
  }

  .footer{
    background: #000;
  }
  .footerInner{
    text-align: center;
    background: #921818;
    padding: 5%;
    clip-path: polygon(8% 5%, 30% 6%, 55% 1%, 64% 8%, 84% 8%, 97% 22%, 92% 32%, 94% 60%, 98% 76%, 92% 88%, 85% 97%, 61% 89%, 46% 94%, 34%
                       98%, 27% 92%, 7% 93%, 4% 76%, 11% 65%, 3% 50%, 5% 28%, 2% 14%);
  }


  .barItem a:hover::before,
  .barItem a:hover::after,
  .barItem a:focus::before,
  .barItem a:focus::after {
    opacity: 0.7;
    transform: scale(1.2);
  }
  .opacity-enter-active {
    transition: opacity 1s;
  }
  .opacity-leave-active {
    transition: opacity 0.8s;
  }
  .opacity-enter,
  .opacity-leave-to {
    opacity: 0;
  }

  .polygon-enter-active {
    animation: 1s polygon reverse;
  }
  .polygon-leave-active {
    animation: 1s polygon;
  }

  @keyframes polygon {
    0% {
      clip-path: polygon(0 0, 50% 0, 100% 0, 100% 50%, 100% 100%, 50% 100%, 0 100%, 0 50%);
    }
    100% {
      clip-path: polygon(50% 50%, 50% 25%, 50% 50%, 75% 50%, 50% 50%, 50% 75%, 50% 50%, 25% 50%);
    }
  }

  .shutters-enter-active {
    animation: 1s shutters reverse;
  }
  .shutters-leave-active {
    animation: 1s shutters;
  }

  @keyframes shutters {
    0% {
      clip-path: polygon(
        0% 0%,
        20% 0%,
        20% 100%,
        20% 100%,
        20% 0%,
        40% 0%,
        40% 100%,
        40% 100%,
        40% 0%,
        60% 0%,
        60% 100%,
        60% 100%,
        60% 0%,
        80% 0%,
        80% 100%,
        80% 100%,
        80% 0%,
        100% 0%,
        100% 100%,
        0% 100%
      );
    }
    100% {
      clip-path: polygon(
        20% 0%,
        20% 0%,
        20% 100%,
        40% 100%,
        40% 0%,
        40% 0%,
        40% 100%,
        60% 100%,
        60% 0%,
        60% 0%,
        60% 100%,
        80% 100%,
        80% 0%,
        80% 0%,
        80% 100%,
        100% 100%,
        100% 0%,
        100% 0%,
        100% 100%,
        20% 100%
      );
    }
  }

  .melt-enter-active {
    animation: 2s melt-enter;
  }
  .melt-leave-active {
    animation: 2s melt-leave;
  }

  @keyframes melt-enter {
    0% {
      clip-path: path(
        'M0 -0.12C8.33 -8.46 16.67 -12.62 25 -12.62C37.5 -12.62 35.91 0.15 50 -0.12C64.09 -0.4 62.5 -34.5 75 -34.5C87.5 -34.5 87.17 -4.45 100 -0.12C112.83 4.2 112.71 -17.95 125 -18.28C137.29 -18.62 137.76 1.54 150.48 -0.12C163.19 -1.79 162.16 -25.12 174.54 -25.12C182.79 -25.12 191.28 -16.79 200 -0.12L200 -34.37L0 -34.37L0 -0.12Z'
      );
    }
    100% {
      clip-path: path(
        'M0 199.88C8.33 270.71 16.67 306.13 25 306.13C37.5 306.13 35.91 231.4 50 231.13C64.09 230.85 62.5 284.25 75 284.25C87.5 284.25 87.17 208.05 100 212.38C112.83 216.7 112.71 300.8 125 300.47C137.29 300.13 137.76 239.04 150.48 237.38C163.19 235.71 162.16 293.63 174.54 293.63C182.79 293.63 191.28 262.38 200 199.88L200 0.13L0 0.13L0 199.88Z'
      );
    }
  }

  @keyframes melt-leave {
    0% {
      clip-path: path(
        'M0 0C8.33 -8.33 16.67 -12.5 25 -12.5C37.5 -12.5 36.57 -0.27 50 0C63.43 0.27 62.5 -34.37 75 -34.37C87.5 -34.37 87.5 -4.01 100 0C112.5 4.01 112.38 -18.34 125 -18.34C137.62 -18.34 138.09 1.66 150.48 0C162.86 -1.66 162.16 -25 174.54 -25C182.79 -25 191.28 -16.67 200 0L200 200L0 200L0 0Z'
      );
    }
    100% {
      clip-path: path(
        'M0 200C8.33 270.83 16.67 306.25 25 306.25C37.5 306.25 36.57 230.98 50 231.25C63.43 231.52 62.5 284.38 75 284.38C87.5 284.38 87.5 208.49 100 212.5C112.5 216.51 112.38 300.41 125 300.41C137.62 300.41 138.09 239.16 150.48 237.5C162.86 235.84 162.16 293.75 174.54 293.75C182.79 293.75 191.28 262.5 200 200L200 200L0 200L0 200Z'
      );
    }
  }

  .spotlight-enter-active {
    animation: 2s spotlight reverse;
  }
  .spotlight-leave-active {
    animation: 2s spotlight;
  }

  @keyframes spotlight {
    0% {
      clip-path: circle(100% at 50% 50%);
    }
    25% {
      clip-path: circle(20% at 50% 50%);
    }
    50% {
      clip-path: circle(20% at 12% 84%);
    }
    75% {
      clip-path: circle(20% at 93% 51%);
    }
    100% {
      clip-path: circle(20% at -30% 20%);
    }
  }

  // vue-burger-menu

  .bm-burger-button {
     position: absolute;
     width: 36px;
     height: 30px;
     right: 15px;
     top: 9px;
     cursor: pointer;
   }
   .bm-burger-bars {
     background-color: #921818;
   }
   .line-style {
     position: absolute;
     height: 12%;
     left: 0;
     right: 0;
   }
   .cross-style {
     position: absolute;
     top: 12px;
     right: 2px;
     cursor: pointer;
   }
   .bm-cross {
     background: #921818;
   }
   .bm-cross-button {
     height: 24px;
     width: 24px;
   }
   .bm-menu {
     height: 100%; /* 100% Full-height */
     width: 0; /* 0 width - change this with JavaScript */
     position: fixed; /* Stay in place */
     z-index: 1000; /* Stay on top */
     top: 0;
     left: 0;
     background-color: #921818; /* red */
     overflow-x: hidden; /* Disable horizontal scroll */
     padding-top: 60px; /* Place content 60px from the top */
     transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
   }

   .bm-cross{
      background: black;
   }

   .bm-overlay {
     background: rgba(0, 0, 0, 0.6);
   }
   .bm-item-list {
     color: #000;
     margin-left: 10%;
     font-size: 20px;
   }
   .bm-item-list > * {
     display: flex;
     text-decoration: none;
     padding: 0.7em;
   }
   .bm-item-list > * > span {
     margin-left: 10px;
     font-weight: 700;
     color: white;
   }
   .opacity{
     transition: opacity 0.5 ease;
   }
   .banner {
      position: absolute;
      top: 12%;
      right: -7%;
      z-index: 10;
      display: inline-block;
      font-size: 42px;
      width: 30%;
      text-align: center;
      padding: .25em 0;
      color: black;
      opacity: 0;
      background: #fff;
    }
    .progress-bar-container--container {
      position: absolute !important;
      width: 100%;
      top: -8px !important;
      left: 0;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue